import { render, staticRenderFns } from "./PyrlSrvcMgmt.vue?vue&type=template&id=52bb99b8&"
import script from "./PyrlSrvcMgmt.vue?vue&type=script&lang=js&"
export * from "./PyrlSrvcMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports